/** PROVISIONAL placeholder: seconds the recall channel must run uninterrupted. Shared by the server timer and the HUD bar. */
export const RECALL_CHANNEL_S = 5;

/** PROVISIONAL placeholder: seconds after a recall completes before another may start. A cancelled channel does not start it. */
export const RECALL_COOLDOWN_S = 60;
